import { render, staticRenderFns } from "./metric_tile.vue?vue&type=template&id=548169c2"
import script from "./metric_tile.vue?vue&type=script&lang=js"
export * from "./metric_tile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports